import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('alofisa_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fetchProducts = (params = {}) => api.get('/products', { params }).then((r) => r.data);
export const fetchProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const fetchCategories = () => api.get('/categories').then((r) => r.data);
export const fetchBrands = () => api.get('/brands').then((r) => r.data);
export const submitQuote = (data) => api.post('/quote-requests', data).then((r) => r.data);
export const submitContact = (data) => api.post('/contact-messages', data).then((r) => r.data);
export const adminLogin = (email, password) => api.post('/auth/login', { email, password }).then((r) => r.data);
export const adminMe = () => api.get('/auth/me').then((r) => r.data);
export const adminListQuotes = (status = 'all') => api.get('/admin/quote-requests', { params: { status } }).then((r) => r.data);
export const adminGetQuote = (id) => api.get(`/admin/quote-requests/${id}`).then((r) => r.data);
export const adminUpdateStatus = (id, status) => api.patch(`/admin/quote-requests/${id}`, { status }).then((r) => r.data);
export const adminReplyQuote = (id, subject, body) => api.post(`/admin/quote-requests/${id}/reply`, { subject, body }).then((r) => r.data);
export const adminDeleteQuote = (id) => api.delete(`/admin/quote-requests/${id}`).then((r) => r.data);
export const adminListContacts = () => api.get('/admin/contact-messages').then((r) => r.data);
export const adminDeleteContact = (id) => api.delete(`/admin/contact-messages/${id}`).then((r) => r.data);
export const adminStats = () => api.get('/admin/stats').then((r) => r.data);

export const CATEGORIES = [
  { slug: 'alimentation', name: 'Alimentation' },
  { slug: 'maison-decoration', name: 'Maison & Décoration' },
  { slug: 'multimedia-informatique', name: 'Multimédia & Informatique' },
  { slug: 'vins-spiritueux', name: 'Vins & Spiritueux' },
];
